import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import importDirective from '@/directive'
import i18n from '@/locale'
import '@/assets/icons/iconfont.css'

// import './mock'

const app = createApp(App)

importDirective(app)

app.use(store)
  .use(router)
  .use(i18n)
  .use(ViewUIPlus, { i18n })
  .mount('#app')
